var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defaultTxData, defaultTxOperation, defaultTxValue } from "./constants";
import { toHex } from "./hexData";
import { toBigInt } from "./units";
export var OperationType;
(function (OperationType) {
    OperationType[OperationType["Call"] = 0] = "Call";
    OperationType[OperationType["DelegateCall"] = 1] = "DelegateCall";
})(OperationType || (OperationType = {}));
export class TransactionError extends Error {
    constructor(message, revertData, revertMessage) {
        super(message);
        this.revertData = revertData;
        this.revertMessage = revertMessage;
    }
}
export function standardizeTransaction(tx) {
    return {
        operation: tx.operation ? tx.operation : defaultTxOperation,
        to: tx.to,
        value: tx.value ? tx.value.toString() : defaultTxValue.toString(),
        data: tx.data ? tx.data : defaultTxData,
    };
}
export function normalizeGasLimit(options) {
    const { gas, gasLimit } = options, rest = __rest(options, ["gas", "gasLimit"]);
    if (gas != null && gasLimit != null) {
        throw new Error(`specified both gas and gasLimit on options: ${options}`);
    }
    return Object.assign(Object.assign({}, rest), { gas: gas || gasLimit });
}
export function formatCallTx(tx) {
    const { from, to, value, data, gas } = normalizeGasLimit(tx);
    return {
        from,
        to,
        value: !value ? undefined : toHex(value),
        data,
        gas: !gas ? undefined : toHex(gas),
    };
}
export function formatCallTxViem(tx) {
    const { from, to, value, data, gas, gasPrice } = normalizeGasLimit(tx);
    return {
        to: to,
        from: !from ? undefined : from,
        value: !value ? undefined : toBigInt(value),
        data: data,
        gas: !gas ? undefined : toBigInt(gas),
        gasPrice: !gasPrice ? undefined : toBigInt(gasPrice),
    };
}
export function prepareSendTransactionViem(tx, walletClient, publicClient) {
    return __awaiter(this, void 0, void 0, function* () {
        const { from, to, value, data, gas, gasPrice, nonce, nonceOffset } = normalizeGasLimit(tx);
        const res = yield walletClient.prepareTransactionRequest({
            type: "legacy",
            account: from,
            to: to,
            data: data,
            gas: !gas ? undefined : toBigInt(gas),
            gasPrice: !gasPrice ? undefined : toBigInt(gasPrice),
            value: !value ? undefined : toBigInt(value),
            nonce: !nonce ? undefined : parseInt(nonce.toString()),
            chain: publicClient.chain,
        });
        if (res.nonce && nonceOffset) {
            res.nonce += parseInt(nonceOffset.toString());
        }
        return res;
    });
}
